let ColorConverter = {
  toRGB,
  toHSV,
  toHSL,
};

let colourNames = 'white gray black'.split(' ');

let builtSwatchCount = 0;

let swapping = false;
let swappingElt   = false;
let swapWithElt   = false;

let compareContainer = document.querySelector('.compare');
let compareInput = document.querySelector('.compare__input');
let colourElts= [];

var clipboard = new Clipboard('.data');


/*document.addEventListener('mouseup', swapSelectedSwatches, false);
document.addEventListener('mouseleave', swapSelectedSwatches, false);*/

buildModal();

Array.prototype.forEach.call(
  document.querySelectorAll('color'),
  buildSwatch
);
clipboard.on('success', displayModal);
clipboard.on('error', errorModal);

//compareInput.addEventListener('keyup', updateCompare, false);

/*
function swapSelectedSwatches () {
'use strict';
	if (swapping && swapWithElt) {
    swapSwatches(swappingElt, swapWithElt);
  }
  swapping = false;
  swapWithElt = false;
  swappingElt = false;
}

function swapSwatches (swapping, swapWith) {
  let swappingOrder = swapping.style.order;
  let swapWithOrder = swapWith.style.order;
  swapping.style.order = swapWithOrder;
  swapWith.style.order = swappingOrder;
}

function updateCompare (e) {
  let val = compareInput.value.toUpperCase();
  
  if (val.length < 7) {
    if (/^[^#]/.test(val) && (val.length === 3 || val.length === 6)) {
      val = `#${val}`;
    }
    if (val.length === 4  &&  /^#/.test(val)) {
      val = `#${val[1]}${val[1]}${val[2]}${val[2]}${val[3]}${val[3]}`;
    }
  }
  
  //  If it's a valid hex value
  if (isHex(val)) {
    compareContainer.style.backgroundColor = document.body.style.backgroundColor = val;
    val = toRGB(val);
    val = toHSL(val);
    
    if (val.l < 45) {
      compareInput.style.color = '#fff';
    } else {
      compareInput.style.color = '#000';
    }
  } else {
    compareContainer.style.backgroundColor = document.body.style.backgroundColor = '#fff';
    compareInput.style.color = '#000';
  };
}*/

function isHex(val) {
'use strict';
  return /^#(([0-9A-F]{3})|([0-9A-F]{6}))$/i.test(val);
}

function buildModal () {
	'use strict';
  var modal = document.createElement('h1');
  modal.className = 'modal';
  document.body.appendChild( modal );
}


var element1 = document.createElement('a');
element1.text = "Go To Automotive Leather & Vinyl Dye";
element1.setAttribute("href", "https://autoleatherdye.com/collections/leather-repair-kits");
element1.setAttribute("class", "MLink");

var element2 = document.createElement('a');
element2.text = "Go To Automotive Leather & Vinyl Repair Kit";
element2.setAttribute("href", "https://autoleatherdye.com/collections/leather-repair-kits");
element2.setAttribute("class", "MLink");

function displayModal (e) {
	'use strict';
  let modal = document.querySelector('.modal');	

	modal.innerText = 'Copied: ' + e.text ;
	modal.appendChild(element1);
		modal.appendChild(element2);


  modal.classList.add( 'show' );
	setTimeout(function() {
    modal.classList.remove( 'show' );	

  }, 50000);
	
	
  if (isHex(e.text)) {
    compareInput.value = e.text;
    updateCompare();
  }  
	

}





function errorModal (e) {
	'use strict';
  let modal = document.querySelector('.modal');
  
  modal.innerText = 'Sorry, I can\'t copy on your browser.';
  modal.classList.add( 'show' );
  modal.classList.add( 'error' );
}


function buildSwatch ( elt ) {
	'use strict';
  builtSwatchCount += 1;
  let empty   = elt.getAttribute( 'empty' );
  if ( typeof empty === 'string' && empty !== 'false' ) { return; }
  
  let name    = elt.getAttribute( 'name' );
  let code = elt.getAttribute( 'code' );
  let hex     = elt.getAttribute( 'hex' ).replace( '#', '' );
  let rgb     = ColorConverter.toRGB(hex);
  let hsl     = ColorConverter.toHSL(rgb);
  let cmyk    = elt.getAttribute( 'cmyk' );
  let pantone = elt.getAttribute( 'pantone' );
  let constrain_elt = document.createElement('div');
  let sizer_elt     = document.createElement('div');
  let wrapper_elt   = document.createElement('div');
  constrain_elt.className = 'constrain';
  sizer_elt.className     = 'sizer';
  wrapper_elt.className   = 'wrapper';
  
  let hex_elt        = document.createElement('h3');
  let hexVal_elt     = document.createElement('span');
  let name_elt       = document.createElement('h3');
  let code_elt = document.createElement('p');
  let rgb_elt        = document.createElement('p');
  let rgbVal_elt     = document.createElement('span');
  let cmyk_elt       = document.createElement('p');
  let cmykVal_elt    = document.createElement('span');
  let hsl_elt        = document.createElement('p');
  let hslVal_elt     = document.createElement('span');
  let pantone_elt    = document.createElement('p');
  let pantoneVal_elt = document.createElement('span');
  
  
  let hex_val     = hex;
  let name_val    = name;
  let code_val = code;
  let rgb_val     = rgb.array().join(', ');
  let hsl_val     = hsl.array().join(', ');
  let cmyk_val    = cmyk;
  let pantone_val = pantone;
  
  elt.style.backgroundColor = '#' + hex;
  elt.style.order = builtSwatchCount;
  elt.addEventListener('mousedown', function() {
    swapping = true;
    swappingElt = elt;
  }, false);
  elt.addEventListener('mouseenter', function() {
    if (swapping) {
      swapWithElt = elt;
    }
  }, false);
  
  if ( name_val !== null ) {
    name_elt.innerHTML  = name_val;
  }
  code_elt.innerHTML = code_val;
  hex_elt.innerHTML     = '#';
  hexVal_elt.innerHTML  = hex_val;
  rgb_elt.innerHTML     = 'RGB: ';
  rgbVal_elt.innerHTML  = rgb_val;
  hsl_elt.innerHTML     = 'HSL: ';
  hslVal_elt.innerHTML  = hsl_val;
  if ( cmyk !== null ) {
    cmyk_elt.innerHTML    = 'CMYK*: ';
    cmykVal_elt.innerHTML = cmyk_val;
  }
  if ( pantone !== null ) {
    pantone_elt.innerHTML    = 'Pantone: ';
    pantoneVal_elt.innerHTML = pantone_val;
  }
  
  if ( hsl.l < 45 ) {
    elt.style.color = 'white';
  }
  
  //hex_elt.oncontextmenu     = e=>{e.preventDefault(); prompt('hex:',     hex_val);};
  //hex_elt.onclick           = e=>{e.preventDefault(); prompt('hex:',     '#' + hex_val);};
  //name_elt.oncontextmenu    =
  //name_elt.onclick          = e=>{e.preventDefault(); prompt('name:',    name_val);};
  //rgb_elt.oncontextmenu     = e=>{e.preventDefault(); prompt('rgb:',     rgb_val);};
  //rgb_elt.onclick           = e=>{e.preventDefault(); prompt('rgb:',     'rgb(' + rgb_val + ')');};
  //hsl_elt.oncontextmenu     = e=>{e.preventDefault(); prompt('hsl:',     hsl_val);};
  //hsl_elt.onclick           = e=>{e.preventDefault(); prompt('hsl:',     'hsl(' + hsl_val + ')');};
  //cmyk_elt.oncontextmenu    =
  //cmyk_elt.onclick          = e=>{e.preventDefault(); prompt('cmyk:',    cmyk_val);};
  //pantone_elt.oncontextmenu =
  //pantone_elt.onclick       = e=>{e.preventDefault(); prompt('pantone:', pantone_val);};
  
  hex_elt.setAttribute(     'data-clipboard-text', '#' + hex_val );
  name_elt.setAttribute(    'data-clipboard-text', code_val);
  code_elt.setAttribute ( 'data-clipboard-text', code_val);
  rgb_elt.setAttribute(     'data-clipboard-text', 'rgb(' + rgb_val + ')' );
  hsl_elt.setAttribute(     'data-clipboard-text', 'hsl(' + hsl_val + ')' );
  cmyk_elt.setAttribute(    'data-clipboard-text', cmyk_val );
  pantone_elt.setAttribute( 'data-clipboard-text', pantone_val );
  
  hex_elt.className =
  name_elt.className =
  code_elt.className =
  rgb_elt.className =
  hsl_elt.className =
  cmyk_elt.className =
  pantone_elt.className = 'data';
  
  constrain_elt.appendChild( sizer_elt );
  sizer_elt.appendChild( wrapper_elt );
  //hex_elt.appendChild( hexVal_elt );
 // wrapper_elt.appendChild( hex_elt );
  wrapper_elt.appendChild( name_elt );
  wrapper_elt.appendChild( code_elt );
  //rgb_elt.appendChild( rgbVal_elt );
 //wrapper_elt.appendChild( rgb_elt );
  //hsl_elt.appendChild( hslVal_elt );
  //wrapper_elt.appendChild( hsl_elt );
  //cmyk_elt.appendChild( cmykVal_elt );
  //wrapper_elt.appendChild( cmyk_elt );
  //pantone_elt.appendChild( pantoneVal_elt );
  //wrapper_elt.appendChild( pantone_elt );
  elt.appendChild( constrain_elt );
  
  colourElts.push(elt);
}


function HSV(h, s, v) {
  if (h <= 0) { h = 0; }
  if (s <= 0) { s = 0; }
  if (v <= 0) { v = 0; }
 
  if (h > 360) { h = 360; }
  if (s > 100) { s = 100; }
  if (v > 100) { v = 100; }
 
  this.h = h;
  this.s = s;
  this.v = v;
  this.array = function() {
    return [this.h, this.s, this.v];
  };
}
 
function HSL(h, s, l) {
	'use strict';
  if (h <= 0) { h = 0; }
  if (s <= 0) { s = 0; }
  if (l <= 0) { l = 0; }
 
  if (h > 360) { h = 360; }
  if (s > 100) { s = 100; }
  if (l > 100) { l = 100; }
 
  this.h = h;
  this.s = s;
  this.l = l;
  this.array = function() {
    return [this.h, this.s, this.l];
  };
}
 
function RGB(r, g, b) {
	'use strict';
  if (r <= 0) { r = 0; }
  if (g <= 0) { g = 0; }
  if (b <= 0) { b = 0; }
 
  if (r > 255) { r = 255; }
  if (g > 255) { g = 255; }
  if (b > 255) { b = 255; }
 
  this.r = r;
  this.g = g;
  this.b = b;
  this.array = function() {
    return [this.r, this.g, this.b];
  };
}
 
function CMYK(c, m, y, k) {
	'use strict';
  if (c <= 0) { c = 0; }
  if (m <= 0) { m = 0; }
  if (y <= 0) { y = 0; }
  if (k <= 0) { k = 0; }
 
  if (c > 100) { c = 100; }
  if (m > 100) { m = 100; }
  if (y > 100) { y = 100; }
  if (k > 100) { k = 100; }
 
  this.c = c;
  this.m = m;
  this.y = y;
  this.k = k;
  this.array = function() {
    return [this.c, this.m, this.y, this.k ];
  };
}
 
function colourName (_clr1, _clr2) {
	'use strict';
  let clr = _clr1 ?
      _clr1.trim().replace(/ /g, '-').toLowerCase() :
      _clr2.trim().replace(/ /g, '-').toLowerCase();
  for(let i = 0; i < colourNames.length; ++i) {
    if (clr.indexOf(colourNames[i]) > -1) {
      return `$${clr}`;
    }
  }
  return `$c-${clr}`;
}

 
function toRGB   (HEX) {
	'use strict';
  let result = new RGB(0, 0, 0);
  let parts = HEX.match(/[0-9a-fA-F]{1,2}/g);
  
  parts.forEach(function(part, i) {
    parts[i] = parseInt(part, 16);
  });
  
  result.r = parts[0];
  result.g = parts[1];
  result.b = parts[2];
  
  return result;
}

function toHSV   (RGB) {
  let result = new HSV(0, 0, 0);

  let r = RGB.r / 255;
  let g = RGB.g / 255;
  let b = RGB.b / 255;

  let minVal = Math.min(r, g, b);
  let maxVal = Math.max(r, g, b);
  let delta = maxVal - minVal;

  result.v = maxVal;

  if (delta == 0) {
    result.h = 0;
    result.s = 0;
  } else {
    result.s = delta / maxVal;
    let del_R = (((maxVal - r) / 6) + (delta / 2)) / delta;
    let del_G = (((maxVal - g) / 6) + (delta / 2)) / delta;
    let del_B = (((maxVal - b) / 6) + (delta / 2)) / delta;

    if (r == maxVal) { result.h = del_B - del_G; }
    else if (g == maxVal) { result.h = (1 / 3) + del_R - del_B; }
    else if (b == maxVal) { result.h = (2 / 3) + del_G - del_R; }

    if (result.h < 0) { result.h += 1; }
    if (result.h > 1) { result.h -= 1; }
  }

  result.h = Math.round(result.h * 360);
  result.s = Math.round(result.s * 100);
  result.v = Math.round(result.v * 100);

  return result;
}

function toHSL (RGB) {
  let result = new HSL(0, 0, 0);
  
  let r = RGB.r/255;
  let g = RGB.g/255;
  let b = RGB.b/255;
  
  let max = Math.max(r, g, b);
  let min = Math.min(r, g, b);
  let h;
  let s;
  let l = (max + min) / 2;

  if(max == min){
    h = s = 0; // achromatic
  }else{
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch(max){
      case r: h = (g - b) / d + (g < b ? 6 : 0); break;
      case g: h = (b - r) / d + 2; break;
      case b: h = (r - g) / d + 4; break;
    }
    h /= 6;
  }
  
  result.h = Math.round(h*360);
  result.s = Math.round(s*100);
  result.l = Math.round(l*100);

  return result;
}